import colors from '@/sass/variables.scss'
import { eventTypes } from './event-helpers'

export default {
  computed: {
    propertyStatus () {
      return Object.freeze({
        NO_SENSORS: {
          color: '#929292',
          description: 'No Sensors At Property',
        },
        ACTIVE_NOISE: {
          color: colors.error,
          description: 'Active Noise Event',
        },
        ACTIVE_TAMPER: {
          color: colors.error,
          description: 'Active Tamper Event',
        },
        SENSORS_OFFLINE: {
          color: '#E19147',
          description: '1 or More Sensors Offline',
        },
        SENSORS_ONLINE: {
          color: '#33A08E',
          description: 'All Sensors Online',
        },
      })
    },
    statusItems () {
      return [
        { label: 'Online', color: 'success', value: 'online' },
        { label: 'Connectivity Issues', color: 'warning', value: 'offline' },
        { label: 'Active Events', color: 'error', value: 'active' },
        { label: 'Inactive', color: '#535353', value: 'inactive' },
      ]
    },
  },
  methods: {
    getPropertyStatus (activityZoneCount, activeEvents) {
      if (activityZoneCount === 0) return this.propertyStatus.NO_SENSORS
      else {
        if (activeEvents && activeEvents.length) {
          const evtArray = activeEvents.map(evt => evt.eventClass)
          if (evtArray.includes(eventTypes.NOISE)) { return this.propertyStatus.ACTIVE_NOISE }
          if (evtArray.includes(eventTypes.TAMPER)) { return this.propertyStatus.ACTIVE_TAMPER }
          if (
            evtArray.includes(eventTypes.DISCONNECT) ||
            evtArray.includes(eventTypes.LOST_NETWORK)
          ) { return this.propertyStatus.SENSORS_OFFLINE }
        }
        return this.propertyStatus.SENSORS_ONLINE
      }
    },
  },
}
